import React from 'react';
import './Policies.css'; // Reusing some base styles for consistency

const Disclaimer = () => {
    return (
        <div className="policies-container disclaimer-container">
            <div className="policies-header">
                <h1>Disclaimer</h1>
            </div>

            <div className="policies-content">
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <img
                        src="/images/disclaimer.jpg"
                        alt="Disclaimer"
                        style={{ maxWidth: '100%', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                        onError={(e) => e.target.style.display = 'none'} // Fallback if image not found
                    />
                </div>

                <section>
                    <p>
                        Every effort has been made to ensure accuracy of data on this web site. However these need to be verified by and supplemented with documents issued finally by the concerned authorities. National Informatics Centre, will not be responsible for any decision or claim that is based on the basis of displayed data. In no event will NIC be liable for any expense, loss or damage including, without limitation, indirect or consequential loss or damage, or any expense whatsoever arising from use, or loss of use, of data, arising out of or in connection with the use of this Portal.
                    </p>
                </section>

                <section>
                    <p>
                        Links to other websites that have been included on this Portal are provided for public convenience only. NIC is not responsible for the contents or reliability of linked websites and does not necessarily endorse the view expressed within them. We cannot guarantee the availability of such linked pages at all times.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default Disclaimer;
